import { RgbaColor, colord, extend } from 'colord';
import { RgbaColorPicker } from 'react-colorful';
import styled from 'styled-components';

import namesPlugin from 'colord/plugins/names';

extend([namesPlugin]);

export const ColorPicker = ({
  rgba,
  onChange,
}: {
  rgba?: RgbaColor;
  onChange: (newValue: string | undefined) => void;
}) => {
  return (
    <Container>
      <RgbaColorPicker color={rgba} onChange={(newValue) => onChange(colord(newValue).toHex())} />
    </Container>
  );
};

const Container = styled.div`
  .react-colorful__pointer {
    width: 18px;
    height: 18px;
    border: 1.5px solid #fff;
  }

  .react-colorful__saturation {
    border-radius: var(--radius-2) var(--radius-2) 0 0;
  }

  .react-colorful__hue {
    height: 17px;
  }

  .react-colorful__alpha {
    height: 17px;
    border-radius: 0 0 var(--radius-2) var(--radius-2);
  }
`;
